import { render, staticRenderFns } from "./_certif.vue?vue&type=template&id=4524df34&scoped=true"
import script from "./_certif.vue?vue&type=script&lang=js"
export * from "./_certif.vue?vue&type=script&lang=js"
import style0 from "./_certif.vue?vue&type=style&index=0&id=4524df34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4524df34",
  null
  
)

export default component.exports